import { sntLog } from "src/app/common/logger";

const logger = sntLog("AccountNickname");
let accountNickName = "";

export function getCurrentAccountNickName(): string {
  return accountNickName;
}

export function setAccountNickName(value: string): void {
  accountNickName = value;
  logger.debug(`account nick name: "${value}"`);
}
